import { Injectable } from '@angular/core';
import { AppService } from 'src/app/app.service';
import { APP_BLOB_CONFIGURATION, CONFIG_KLEARDEMO, CONFIG_PRE_PROD, DEMO, PRODUCTION, SANDBOX, SIT, UAT } from '../../constant/constant';

@Injectable({
  providedIn: 'root'
})
export class AppConfigurationService {

  appBlobConfiguration: any;

  constructor( private appService: AppService ) {
    this.appBlobConfiguration = APP_BLOB_CONFIGURATION;
  }

  getAppLogo(environment: any = null, client: any = null): string {
    let logo, logoUrl, folder;

    let isEnvironmentProd = environment === PRODUCTION;
    let isEnvironmentDemo = environment === DEMO;
    let isEnvironmentUat = environment === UAT;
    let isEnvironmentSb = environment === SANDBOX;
    let isEnvironmentSit = environment === SIT;
    let isEnvironmentKlearDemo = environment == CONFIG_KLEARDEMO;
    let isEnvironmentPreprod = environment == CONFIG_PRE_PROD;

    if( isEnvironmentKlearDemo || isEnvironmentProd || isEnvironmentDemo || isEnvironmentUat || isEnvironmentSb || isEnvironmentSit || isEnvironmentPreprod) {
      logo = client + '.png';
    } else {
      logo = environment + '.png';
    }

    if( environment.indexOf('dev') !== -1 ) {
      folder = 'dev/'
    } else if( environment.indexOf('qa') !== -1 ) {
      folder = 'qa/'
    } else if( environment.indexOf('localhost') !== -1 ) {
      folder = 'dev/'
    } else {
      folder = 'clients/'
    }

    logoUrl = this.appBlobConfiguration.blobSassUrl + this.appBlobConfiguration.container + this.appBlobConfiguration.logoDirectory + folder + logo + this.appBlobConfiguration.token;
    return logoUrl;
  }
}